module.exports = __webpack_public_path__ + "static/media/muli-latin-700.a6600f60.woff";